import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const useDetectURLChange = (successCb = () => {}) => {
  const history = useHistory();
  let urlChanged = false;

  useEffect(() => {
    const urlChangeListener = history?.listen((location) => {
      // route change
      if (location?.pathname) {
        urlChanged = true;
        successCb?.();
      } else {
        urlChanged = false;
      }
    });

    return urlChangeListener;
  }, [history]);

  return [urlChanged];
};

export default useDetectURLChange;
